import { defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
import ResourceList from "./resource-list.vue";
import AddResourceToPlayable from "./add-resource-to-used.vue";
import defaultZip from "@/assets/playturbo/default-zip.png";
export default defineComponent({
    props: {
        resources: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        }
    },
    inject: [
        "show",
        "hide"
    ],
    components: {
        ResourceList: ResourceList,
        AddResourceToPlayable: AddResourceToPlayable
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var getImageComponents = function() {};
        var handleAddResource = function(res) {
            emit("addResource", res);
        };
        return {
            getImageComponents: getImageComponents,
            handleAddResource: handleAddResource,
            defaultZip: defaultZip
        };
    }
});
